export default {
  'welcome.title': 'Chào mừng đến với',
  'welcome.sub': 'Starbucks Rewards™',
  'welcome.text.content1':
    'Vui lòng xác nhận địa chỉ email của bạn để bắt đầu! Một đường dẫn xác nhận đã được gửi đến email bạn đã đăng ký, hãy nhấn vào đường dẫn để kích hoạt tài khoản và hoàn thành việc đăng ký.',
  'welcome.text.content2':
    'Nếu bạn không nhận được email có chứa đường dẫn xác nhận trong một vài phút tới, hãy kiểm tra mục Thư rác.',
  'welcome.text.signIn': 'Đăng nhập',
};
